/* eslint-disable import/no-cycle */
import { makeAutoObservable } from 'mobx'
import agent from '../agent'
import { RootStore } from './rootStore'

class ShopStore {
  rootStore: RootStore
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  acceptInfluencer(campaignId: string, influencerId: string, brandId: string) {
    this.rootStore.brandStore.finishApplicantsTodo(campaignId)
    return agent.Shop.acceptInfluencer({ campaignId, influencerId, brandId } as any)
  }

  buyMoreSlots = agent.Shop.buyMoreSlots
  getCouponAfterAcceptingLastInfluencer = agent.Shop.getCouponAfterAcceptingLastInfluencer

  removeInfluencer(brandId: string, campaignId: string, influencerId: string, readd: boolean) {
    return agent.Shop.removeInfluencer({ brandId, campaignId, influencerId, readd } as any)
  }

  denyUgcInfluencer(campaignId: string, influencerId: string, brandId: string, denyText: string) {
    return agent.Shop.denyUgcInfluencer({ campaignId, influencerId, brandId, denyText })
  }
}

export default ShopStore
